var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalanceSheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.695 46.8746C30.7813 46.5967 30.8251 46.3073 30.8251 46.0161C30.8281 45.4706 30.668 44.9368 30.3652 44.4831C30.4312 44.3715 30.4853 44.2535 30.5263 44.1306H31.5457L30.5722 19.4952L29.9282 19.6177C29.0468 19.7864 28.1729 19.9935 27.3376 20.2155L26.939 20.323L25.9962 44.1376H27.0542C27.0953 44.2604 27.149 44.3788 27.2151 44.4904C26.9119 44.9438 26.7517 45.4776 26.7552 46.0233C26.7535 46.3115 26.7949 46.5982 26.8777 46.874C25.8443 47.2566 24.9536 47.9481 24.3271 48.8545C23.7002 49.761 23.3679 50.8385 23.3751 51.9404V52.4998L34.1979 52.5002V51.9404C34.2051 50.8386 33.8729 49.761 33.246 48.8545C32.6195 47.9481 31.7288 47.2565 30.6954 46.874L30.695 46.8746Z",
    fill: "url(#paint0_linear_3403_144011)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.516 42.766L19.5195 42.6665C18.2011 42.559 16.5993 42.4902 14.8748 42.4902C13.1502 42.4902 11.548 42.5515 10.23 42.6665L9.2336 42.766C7.70062 42.9423 6.75 43.1876 6.75 43.4634C6.75 43.7392 7.30194 43.862 8.28298 44.0229L8.70455 44.7894C8.86982 44.9782 9.11312 45.0802 9.36359 45.0655H20.4247C20.6854 45.0963 20.9455 44.9994 21.122 44.8047L21.5436 44.0383C22.4864 43.8774 23.0766 43.6858 23.0766 43.4788C23.0766 43.2718 22.0493 42.9422 20.5163 42.766L20.516 42.766Z",
    fill: "url(#paint1_linear_3403_144011)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4066 36.2969L50.4102 36.1973C49.0917 36.0899 47.49 36.0211 45.7654 36.0211C44.0409 36.0211 42.4387 36.0824 41.1207 36.1973L40.1242 36.2969C38.5912 36.4731 37.6406 36.7185 37.6406 36.9943C37.6406 37.2701 38.1926 37.3929 39.1736 37.5537L39.5952 38.3202V38.3206C39.7604 38.5095 40.0037 38.6111 40.2542 38.5964H51.3074C51.5579 38.6111 51.8012 38.5095 51.9668 38.3206L52.3884 37.5541C53.3311 37.3933 53.9214 37.2016 53.9214 36.9946C53.9214 36.7876 52.94 36.4731 51.407 36.2969H51.4066Z",
    fill: "url(#paint2_linear_3403_144011)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1974 37.83C19.0941 37.3389 19.0554 36.8362 19.0824 36.3353C19.0842 35.7016 18.9288 35.0775 18.6301 34.5187C18.0781 33.576 17.0204 33.047 16.5297 32.0735V32.0738C16.1519 32.2015 15.7612 32.2887 15.3649 32.3342C15.5411 32.4184 15.7098 32.5029 15.8785 32.595H15.8782C16.5054 32.9064 16.9786 33.46 17.1891 34.128C17.2072 34.2145 17.186 34.3049 17.1313 34.3743C17.0765 34.4438 16.9941 34.4855 16.9054 34.4883C16.7638 34.492 16.6392 34.3959 16.6064 34.2583C16.4346 33.7437 16.065 33.319 15.5795 33.0778L15.2883 32.9245C15.4426 33.2198 15.5487 33.5383 15.6024 33.8672C15.6161 33.95 15.5921 34.0345 15.5374 34.0982C15.4826 34.1618 15.4025 34.1981 15.3187 34.1967C15.2427 34.1971 15.1692 34.17 15.1117 34.1201C15.0545 34.0708 15.0166 34.003 15.0046 33.9285C14.893 33.2992 14.5515 32.7335 14.0464 32.3421L13.9468 32.3113C13.6878 32.2757 13.4315 32.222 13.1804 32.1505C12.6897 33.0778 11.6549 33.599 11.1567 34.5112C10.8579 35.07 10.7026 35.6941 10.7043 36.3278C10.7313 36.8288 10.6926 37.3311 10.5893 37.8224C10.3214 38.579 10.2868 39.3989 10.4897 40.1753C10.7991 40.9804 11.5098 41.5632 12.3601 41.7082H17.4802C18.3302 41.5632 19.0409 40.9804 19.3506 40.1753C19.5347 39.3958 19.4813 38.5789 19.1973 37.83L19.1974 37.83ZM14.8742 40.1678C14.2624 40.1781 13.6715 39.9437 13.2328 39.517C12.7941 39.0903 12.5433 38.5062 12.5365 37.8944C12.5296 37.2822 12.7671 36.6929 13.1962 36.2564C13.6256 35.8201 14.2108 35.5727 14.8229 35.5692C15.4351 35.5658 16.0233 35.8064 16.4572 36.2379C16.891 36.6697 17.1354 37.2562 17.1354 37.8683C17.1354 38.4716 16.8986 39.0509 16.4756 39.481C16.0524 39.9112 15.4774 40.1579 14.8742 40.1678V40.1678Z",
    fill: "url(#paint3_linear_3403_144011)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.088 30.9313C49.9847 30.4402 49.946 29.9375 49.9731 29.4367C49.9748 28.8029 49.8194 28.1788 49.5207 27.62C48.9688 26.6773 47.9111 26.1483 47.4203 25.1748V25.1751C47.0426 25.3028 46.6518 25.39 46.2555 25.4356C46.4318 25.5197 46.6005 25.6042 46.7692 25.6963H46.7688C47.396 26.0077 47.8692 26.5613 48.0797 27.2293C48.0979 27.3158 48.0767 27.4062 48.0219 27.4756C47.9672 27.5451 47.8847 27.5869 47.7961 27.5896C47.6544 27.5934 47.5298 27.4972 47.497 27.3596C47.3252 26.845 46.9557 26.4203 46.4701 26.1791L46.1789 26.0258C46.3332 26.3211 46.4393 26.6397 46.493 26.9685C46.5067 27.0513 46.4827 27.1359 46.428 27.1995C46.3732 27.2631 46.2932 27.2994 46.2093 27.298C46.1334 27.2984 46.0598 27.2713 46.0023 27.2214C45.9452 27.1721 45.9072 27.1044 45.8952 27.0298C45.7837 26.4005 45.4421 25.8348 44.937 25.4434L44.8375 25.4126C44.5784 25.3771 44.3221 25.3233 44.071 25.2518C43.5803 26.1791 42.5455 26.7003 42.0473 27.6125C41.7485 28.1713 41.5932 28.7955 41.5949 29.4291C41.6219 29.9301 41.5833 30.4324 41.4799 30.9238C41.212 31.6803 41.1774 32.5002 41.3804 33.2766C41.6897 34.0817 42.4004 34.6645 43.2508 34.8096H48.3708C49.2208 34.6645 49.9315 34.0817 50.2412 33.2766C50.4253 32.4971 50.372 31.6803 50.0879 30.9313L50.088 30.9313ZM45.7649 33.2691C45.153 33.2794 44.5621 33.045 44.1234 32.6183C43.6848 32.1916 43.4339 31.6075 43.4271 30.9957C43.4203 30.3835 43.6577 29.7943 44.0868 29.3577C44.5163 28.9214 45.1014 28.674 45.7135 28.6706C46.3257 28.6671 46.9139 28.9077 47.3478 29.3392C47.7817 29.771 48.026 30.3575 48.026 30.9697C48.026 31.5729 47.7892 32.1522 47.3663 32.5824C46.943 33.0125 46.3681 33.2592 45.7649 33.2691V33.2691Z",
    fill: "url(#paint4_linear_3403_144011)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3427 31.5449C14.3672 31.8306 15.4557 31.7878 16.4545 31.4224C16.7228 30.8246 17.8879 30.2344 17.5888 29.644H17.5892C17.5135 29.4931 17.3592 29.3983 17.1905 29.3987H12.5916C12.4229 29.3983 12.2686 29.4931 12.1929 29.644C11.848 30.3109 13.1969 30.9471 13.3427 31.5448L13.3427 31.5449Z",
    fill: "url(#paint5_linear_3403_144011)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2334 24.6462C45.2578 24.9319 46.3463 24.8891 47.3451 24.5237C47.6134 23.9259 48.7785 23.3357 48.4794 22.7453H48.4798C48.4042 22.5944 48.2498 22.4997 48.0811 22.5H43.4822C43.3135 22.4997 43.1592 22.5944 43.0836 22.7453C42.7386 23.4123 44.0875 24.0484 44.2333 24.6462L44.2334 24.6462Z",
    fill: "url(#paint6_linear_3403_144011)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4445 20.0019L47.3678 19.657C46.8542 17.2042 44.4397 15.4258 40.5769 14.6518L40.5766 14.6515C38.3507 14.2405 36.0813 14.117 33.8239 14.2836C33.0581 12.6764 31.5446 11.5537 29.7845 11.2868C29.8125 10.9973 29.7971 10.7054 29.7386 10.4207C29.6312 9.8818 29.3639 9.38768 28.9721 9.00269C29.0734 8.69609 29.0919 8.36828 29.0255 8.05206L28.9105 7.50012L25.331 8.26661L25.446 8.81855H25.4463C25.5113 9.13507 25.6595 9.42866 25.8754 9.66922C25.6674 10.1712 25.614 10.7235 25.7221 11.2559C25.7803 11.5402 25.8812 11.814 26.0212 12.0686C24.5142 13.0195 23.578 14.6565 23.5222 16.4376C21.386 17.1965 19.3561 18.2269 17.4824 19.5035C14.2556 21.7646 12.7531 24.3554 13.2667 26.8081L13.328 27.1147L14.3702 27.498V28.2644H14.3705C14.3705 28.5355 14.5899 28.7548 14.8609 28.7548C15.1319 28.7548 15.3516 28.5355 15.3516 28.2644V27.4213L16.5934 26.5169L16.5167 26.1645C16.141 24.3786 19.8893 20.6995 27.6383 18.6987C28.1748 18.5608 28.7189 18.4304 29.2479 18.323L30.0144 18.1697C38.1008 16.6367 43.6351 18.4534 44.0407 20.4L44.1098 20.722L45.1754 21.067V21.9867H45.175C45.175 22.2578 45.3947 22.4774 45.6657 22.4774C45.9368 22.4774 46.1561 22.2578 46.1561 21.9867V20.9366L47.4445 20.0019Z",
    fill: "url(#paint7_linear_3403_144011)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.25 40.5C15.9069 40.5 17.25 39.1569 17.25 37.5C17.25 35.8431 15.9069 34.5 14.25 34.5C12.5931 34.5 11.25 35.8431 11.25 37.5C11.25 39.1569 12.5931 40.5 14.25 40.5ZM12.75 37.875C12.75 36.8408 13.5908 36 14.625 36C15.6592 36 16.5 36.8408 16.5 37.875C16.5 38.9092 15.6592 39.75 14.625 39.75C13.5908 39.75 12.75 38.9092 12.75 37.875ZM14.9132 37.2237H15.304V36.9395H13.9421V37.2395L14.3684 37.2394C14.5224 37.2394 14.6527 37.3302 14.7079 37.4645H13.9421V37.7487H14.7079C14.6527 37.8789 14.5224 37.9737 14.3684 37.9737H13.9421V38.3368L14.6329 39.0355L15.0513 39.0355L14.3013 38.2737H14.3684C14.6882 38.2737 14.9566 38.0486 15.0197 37.7487L15.3079 37.7487V37.4645H15.0197C15 37.3776 14.9645 37.2947 14.9132 37.2237Z",
    fill: "url(#paint8_linear_3403_144011)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.75 33.6014C47.4069 33.6014 48.75 32.2583 48.75 30.6014C48.75 28.9446 47.4069 27.6014 45.75 27.6014C44.0931 27.6014 42.75 28.9446 42.75 30.6014C42.75 32.2583 44.0931 33.6014 45.75 33.6014ZM44.25 30.9764C44.25 29.9422 45.0908 29.1014 46.125 29.1014C47.1592 29.1014 48 29.9422 48 30.9764C48 32.0107 47.1592 32.8514 46.125 32.8514C45.0908 32.8514 44.25 32.0107 44.25 30.9764ZM46.4132 30.3251H46.804V30.0409H45.4421V30.3409L45.8684 30.3409C46.0224 30.3409 46.1527 30.4317 46.2079 30.5659H45.4421V30.8501H46.2079C46.1527 30.9804 46.0224 31.0751 45.8684 31.0751H45.4421V31.4383L46.1329 32.137L46.5513 32.1369L45.8013 31.3751H45.8684C46.1882 31.3751 46.4566 31.1501 46.5197 30.8501L46.8079 30.8501V30.5659H46.5197C46.5 30.4791 46.4645 30.3962 46.4132 30.3251Z",
    fill: "url(#paint9_linear_3403_144011)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3403_144011",
    x1: 33.4797,
    y1: 23.2358,
    x2: 13.8363,
    y2: 29.3666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4963"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09152F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3403_144011",
    x1: 21.993,
    y1: 42.7827,
    x2: 21.12,
    y2: 48.0388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4963"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09152F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3403_144011",
    x1: 52.8408,
    y1: 36.3131,
    x2: 51.9683,
    y2: 41.5602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4963"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09152F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3403_144011",
    x1: 18.8542,
    y1: 33.1654,
    x2: 8.82994,
    y2: 42.1753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4963"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09152F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3403_144011",
    x1: 49.7448,
    y1: 26.2667,
    x2: 39.7206,
    y2: 35.2766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4963"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09152F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3403_144011",
    x1: 17.2724,
    y1: 29.6631,
    x2: 15.4572,
    y2: 33.7366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4963"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09152F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3403_144011",
    x1: 48.1631,
    y1: 22.7644,
    x2: 46.3478,
    y2: 26.8379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4963"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09152F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3403_144011",
    x1: 45.1695,
    y1: 9.90899,
    x2: 24.8256,
    y2: 41.1341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4963"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09152F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3403_144011",
    x1: 16.8518,
    y1: 35.18,
    x2: 10.5813,
    y2: 41.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4963"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09152F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3403_144011",
    x1: 48.3518,
    y1: 28.2814,
    x2: 42.0813,
    y2: 34.2494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4963"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09152F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceSheet);
export default __webpack_public_path__ + "static/media/BalanceSheet.31bcd21c9964d298965f5579b2af504e.svg";
export { ForwardRef as ReactComponent };